export default {
  namespaced: true,
  state: {
    isShow: false,
    selected: 1,
    images: [
    ],
  },
  getters: {
    isShow: state => state.isShow,
    images: state => state.images,
    selected: state => {
      let selectedIndex = 0;

      _.some(state.images, (img, index) => {
        if (img.selected) {
          selectedIndex = index;

          return true;
        }

        return false;
      });

      return selectedIndex;
    },
  },
  mutations: {
    setImages(state, images) {
      state.images = images;
    },
    showGallery(state) {
      state.isShow = true;
    },
    hideGallery(state) {
      state.isShow = false;
    },
  },
};
